import React, { FC, ReactNode } from 'react';
import skyBg from '../assets/images/background/SkyWithClouds.png';
import rocksLeft from '../assets/images/background/RocksWithBird.png';
import rocksRight from '../assets/images/background/RocksWithGrass2.png';

interface PageLayoutProps {
  children: ReactNode;
}

const PageLayout: FC<PageLayoutProps> = ({ children }) => {
  return (
    <div className="relative min-h-screen w-full overflow-y-auto overflow-x-hidden flex flex-col bg-gradient-to-b from-[#a4c8e1] via-[#dceaf3] to-white font-['DM_Sans',sans-serif]">
      {/* Background Sky */}
      <div className="absolute top-0 left-0 w-full z-[1] leading-none mix-blend-multiply opacity-80 pointer-events-none">
        <img src={skyBg} alt="" className="w-full h-auto object-cover md:min-h-[220px]" />
      </div>

      {/* Main Content Area */}
      <div className="relative z-[5] flex-1 flex flex-col w-full">
        {children}
      </div>

      {/* Bottom Decorative Assets */}
      <div className="absolute bottom-0 left-0 w-full pointer-events-none z-[2] flex justify-between items-end">
        <img src={rocksLeft} alt="" className="w-[190px] md:w-[220px] lg:w-[250px] xl:w-[280px] h-auto object-contain object-left-bottom" />
        <img src={rocksRight} alt="" className="w-[120px] md:w-[150px] lg:w-[180px] xl:w-[210px] h-auto object-contain object-right-bottom" />
      </div>
    </div>
  );
};

export default PageLayout;